export enum AccountingLocations {
    DOMESTIC = 'Znotraj domače države',
    EU = 'Druga država skupnosti',
}